import checklists from "./modules/checklists"
import comments from "./modules/comments"
import files from "./modules/files"
import milestoneCategories from "./modules/milestoneCategories"
import projects from "./modules/projects"
import taskPriorities from "./modules/taskPriorities"
import tasks from "./modules/tasks"
import taskStatus from "./modules/taskStatus"
import projectCategories from "./modules/projectCategories"
import projectSteps from "./modules/projectSteps"
import alertConfig from "@/Modules/Projects/store/modules/alertConfig";
import customerStatus from "./modules/customerStatus";
import propertySpecifications from "./modules/propertySpecifications";
import projectLogs from "./modules/logs";
import projectsTransferred from "./modules/projectsTransferred";

export default {
    modules: {
        projects,
        milestoneCategories,
        taskPriorities,
        taskStatus,
        tasks,
        checklists,
        files,
        comments,
        projectCategories,
        projectSteps,
        alertConfig,
        customerStatus,
        propertySpecifications,
        projectLogs,
        projectsTransferred
    }
}
